/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import TSBenutzer from './TSBenutzer';
import TSAnlaufstelle from './TSAnlaufstelle';

export default class TSAnlaufstelleWithUsers extends TSAnlaufstelle {

    private _sachbearbeiter: Array<TSBenutzer> = [];
    private _schaetzer: Array<TSBenutzer> = [];

    public get sachbearbeiter(): Array<TSBenutzer> {
        return this._sachbearbeiter;
    }

    public set sachbearbeiter(value: Array<TSBenutzer>) {
        this._sachbearbeiter = value;
    }

    public get schaetzer(): Array<TSBenutzer> {
        return this._schaetzer;
    }

    public set schaetzer(value: Array<TSBenutzer>) {
        this._schaetzer = value;
    }

    deserialize(restObject: any): TSAnlaufstelle {
        super.deserialize(restObject);

        if (restObject.sachbearbeiter) {
            this.sachbearbeiter = restObject.sachbearbeiter.map(TSBenutzer.getDeserializer);
        }

        if (restObject.schaetzer) {
            this.schaetzer = restObject.schaetzer.map(TSBenutzer.getDeserializer);
        }
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.sachbearbeiter = this.arrayToRestObject(this.sachbearbeiter);
        restObject.schaetzer = this.arrayToRestObject(this.schaetzer);

        return restObject;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/TSAnlaufstelleWithUsers.ts